import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AbilityConfig } from "../ability-config/ability-config";
import { StoreService } from '../store.service';
var CasePracticeRevolutionReportComponent = (function () {
    function CasePracticeRevolutionReportComponent(commonService, apiService, route, router, storeService) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.storeService = storeService;
        // 皮肤样式
        this.skinColor = 'Orange';
        this.assetsRoute = "../../assets";
        this.itemClickEnable = false;
    }
    CasePracticeRevolutionReportComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.abilityConfig = new AbilityConfig(this.apiService, this.commonService);
        var that = this;
        this.isShowReportLv = false;
        this.bestPathBoxShow = false;
        this.analysisBoxShow = false;
        this.starShow = false;
        this.pathClickable = true;
        this.goToListClickedStatus = false;
        this.redoClickedStatus = false;
        this.route.queryParams.subscribe(function (queryParams) {
            _this.type = queryParams['type'];
        });
        this.route.params.subscribe(function (params) {
            _this.practiceId = params['practiceId'];
            _this.exerciseId = params['exerciseId'];
            _this.learningPathId = params['learningPathId'];
            _this.updateExerciseReports();
            _this.apiService.ajax({
                'type': 'get',
                'url': '/sr/learningtour',
            }).subscribe(function (result) {
                _this.learningTour = result;
            });
            // this.optimum = '<p class="excellentDemonstrationTitle flowerBorderBottom">优秀示范</p><p class="dialogBox">做完练习之后，你应该感受到变革的艰辛了。你的关键行为有没有满星呢？一起来看看一个优秀主管应该怎么做吧！</p><p class="changeTitle fontBlod">变革start，告诉团队小伙伴！</p><p>作为技术部的主管也是项目负责人，你收到变革消息后，准备在本周二上午10：00给项目组成员开个会。这时，拿出了笔记本，把开会要说明的重点写在了笔记本上。</p><div class="bg-lightOrange"><p class="fontOrange">「最佳选择」</p><p class="smLineHeight">1.受外来竞争影响，A、B、C大客户不断流失，一季度营业额下降10%。</p><p class="smLineHeight">2.拓宽产品类型，各部门抽调成员，成立新的项目组开发新产品。</p><p class="smLineHeight">3.被抽调员工的工作内容和优先级将发生变化。</p><p class="smLineHeight">4.若能率先开发上线，便可抢占先机，赢得市场。</p></div><p>会议开始了，你按照会前准备的重点，跟团队成员进行了阐述。大家反应各不相同。' +
            //   '下属在会议中清楚的知道了什么在变，为什么要变以及对组织的预期收益。在会议结束前，你给团队成员布置了任务。（任务：做调研报告  时间：下周三15：00前）</p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>这个场景中需要运用变革加速器一，说明了变革的内容、愿意及预期收益。主管会议上说的清楚，下属在会活就不会麻烦不断。</p></div><p>如果你在会议上表达清楚，就不会有下面的下属找你麻烦的事情了。</p><p><span class="fontLW">林短信</span><span>老大，为什么要搞这个新项目啊？现在的项目不是盈利很好吗？我们对那个领域又不熟，去了不也是送人头吗？</span></p><p><span class="fontBlue">我</span><span>你也看过我们的业绩报表，对比去年同期，我们营业额下降10%。</span></p><p><span class="fontBlue">我</span><span>正因为大家对这个领域都不熟，我们才有机会抢占先机，对你个人来说也是一个不错的提升机会。</span></p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>可以看出，林薇对于前面的会议上说的变革缘由并不是很清楚。通过告诉林薇营业额的下降和对公司和个人的收益，能够让林薇理解到底为什么要变。</p></div><p><span class="fontWY">魏宇</span><span>老板，听说我们要做编程游戏了，太好了！我之前有关注过这方面的信息，我觉得我们一定能成功！</span></p><p><span class="fontBlue">我</span><span>很高兴听到你这么说，说说看你对这个项目的理解。</span></p><p><span class="fontWY">魏宇</span><span>不就是要开战了嘛？不过我不确定对我来说到底会有怎么样的变化？</span></p><p><span class="fontBlue">我</span><span>这是个全新领域，我们都要学习新的内容。具体做什么我们在项目启动会上会有个初步讨论。目前你需要尽快把手里的工作交接出去，熟悉新项目，把重心放在新产品上。</span></p><p><span class="fontWY">魏宇</span><span>好的，老板。我知道了，我接下来就准备起来了。</span></p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>通过对话可以看出，魏宇对变革是持适应变革的态度的，这个时候，如果不能讲清楚变革的内容，可能就会把下属从适应的阶段推向观望的边缘。</p></div><p><span class="fontKS">柯胜</span><span>老大，我不想做这个新项目！我现在手里的XX产品快要上线，已经忙成狗了！</span></p><p><span class="fontBlue">我</span><span>看起来你是不理解这个决定。我理解这时抽调你过来会打乱你原本的计划，我们需要讨论下解决方案。</span></p><p><span class="fontKS">柯胜</span><span>做这个新产品对我们到底有什么好处啊？</span></p><p><span class="fontBlue">我</span><span>我们的新产品将会是市面上首款此类型的游戏，不仅能帮公司稳固在行业内的地位，提升营业额，而且，我想届时你在游戏产品界的地位，就更是当之无愧的一哥了。</span></p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>很显然柯胜对变革是抗拒的心态，会议中如果没有把变革的对公司、组织或个人的收益，就会出现柯胜这样怒气腾腾的状态。</p></div>' +
            //   '<p class="changeTitle fontBlod">有人抗拒，快去灭火</p><p>已经是周四的上午10:00，你仍然没有收到柯胜的报告。你决定找他聊一聊。</p><p><span class="fontKS">柯胜</span><span>老板，你找我啊。</span></p><p><span class="fontBlue">我</span><span>柯胜，上次会议说到新项目的调研报告，我还没收到你的。我想了解一下，是有什么问题吗？</span></p><p><span class="fontKS">柯胜</span><span>老大，你知道的啊。XXX产品的新版本才刚刚上市，要做的事情很多。我每天晚上整理数据和用户评论都要弄到很晚……</span></p><p>【导师反馈】懂他才能搞定他，了解下属感受是化解抗拒情绪的关键一步。</p><p><span class="fontBlue">我</span><span>我看到你对A产品新版本的热情，现在这个阶段你一定放不开手。</span></p><p><span class="fontKS">柯胜</span><span>是啊，自己一手做出来的产品，交给别人总是不放心啊。</span></p><p>【导师反馈】你很好地同理了下属的情绪，接下来要怎么见招拆招？</p><p><span class="fontBlue">我</span><span>编程游戏的项目势在必行，这个在团队中我也已经沟通多次。可以说说现在让你把重心放到新项目，你自己有什么担心或困难吗？</span></p><p><span class="fontKS">柯胜</span><span>对新项目我的确是有点担心。我跟做这行的朋友聊过，他说这个领域局势很不明朗，大家都还在烧钱，盈利模式也不清楚。现在就要去趟这浑水，我心里有点慌。</span></p><p>【导师反馈】引导下属说出了担忧和疑虑，为你点赞！</p><p><span class="fontBlue">我</span><span>我理解你资源上的压力，还有对新项目前景的担心，让我们一一来解决。先谈什么呢？</span></p><p><span class="fontKS">柯胜</span><span>老实说我主要是担心这个项目的前景，担心公司，也担心自己的投入到时一场空。</span></p><p>【导师反馈】Get到了下属担心的点，接下来要如何回应呢？</p><p><span class="fontBlue">我</span><span>谢谢你的坦诚，公司在确定这个项目前做过一些调研分析，结果是积极的，才会决定启动这个项目。我可以请小A和你分享。（小A分享-语音）</span></p><p><span class="fontOrange">小A</span><span>我们之前已经做过调研，结果还是比较积极的。不过，任何创新过程都存在风险和不确定性，所以需要项目组配合做更深入的调研，我们需要根据调研结果来规划项目并管理风险。</span></p><p><span class="fontBlue">我</span><span>我们团队有责任及时反馈市场和用户信息，帮助公司做决策。就先聚焦在我们能做的部分吧。</span></p><p><span class="fontKS">柯胜</span><span>（无奈脸）也只能这样了。【一脸“有句话不知当不当讲”的样子】</span></p><p>【导师反馈】下属似乎还有顾虑，怎样才能让他心定？</p><p><span class="fontBlue">我</span><span>还是你对新项目有其他担心？没关系，说来听听。</span></p><p><span class="fontKS">柯胜</span><span>我在这块是“小白”，现在要做还真有点不知道该从哪里下手。（我是谁？我从哪里来？我要做什么？……）</span></p><p><span class="fontBlue">我</span><span>对你来说这的确是一个全新的领域，我能理解你的无力感。我们来看看可以做些什么让你快速上手。</span></p><p><span class="fontKS">柯胜</span><span>我可以自己找一些这方面的书或网上的资料，先看起来。</span></p><p>【导师反馈】在你的引导下，下属提出了解决方案，给你撒花花~</p><p><span class="fontBlue">我</span><span>我了解到魏宇对新产品领域是有一些研究的，可以邀请他来做个分享，这样你觉得可以帮助到你尽快熟悉起来吗</span></p><p><span class="fontKS">柯胜</span><span>那当然咯，有他的分享，我想一定能更快熟悉这块的。</span></p><p>【导师反馈】你不仅帮助下属化解了情绪，还提供了支持，给你加鸡腿！</p><p>你帮柯胜把变革中要做的事进行了梳理。（记事本形式呈现）</p><p class="imgBlock"><img style="width: 100%;" src="../../assets/picture/casepracticerevolution/bestRoadNote.png" /></p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>在会议阶段柯胜的抗拒情绪就比较明显了。这个情况下，首先要运用变革加速器二，收集他的感受和想法并且表示同理；然后再运用变革加速器三及鼓励参与，帮助他梳理变革中不可掌控、可掌控、可影响的部分，让他重获掌控感。</p></div>'+
            //   '<p class="changeTitle fontBlod">变革ing，跟进！跟进！再跟进</p><p>两个月之后，你组织项目组成员开了一次会议，会议的目的：</p><div class="bg-lightOrange"><p class="fontOrange">「最佳选择」</p><p class="smLineHeight">1.回顾项目进展。</p><p class="smLineHeight">2.对做得好的给予表扬，加强自信</p><p class="smLineHeight">3.对做得不好的，给予鼓励，维护自尊</p><p class="smLineHeight">4.提供必要的支持</p></div><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>变革过程中的监控和回顾对变革的成功起很大的作用，那么跟进会议就必不可少了，在会议上难道只是跟进项目嘛？并不然，及时奖励、提供支持才能让变革的走向成功。</p></div>'+
            //   '<p>会议开始了，大家轮流进行汇报，首先是开发工程师魏宇汇报工作。</p><p><span class="fontWY">魏宇</span><span>经过这两个月的加班加点，调研的内容已经完成，同时，开发已经……（一切顺利，成果显著）。【具体内容，成果显著】</span></p><p class="fontOrange">「最佳选择」</p><p><span class="fontBlue">我</span><span>大家对你的调研报告评价很高，同时，你还提前完成部分开发工作，给后期的工作打下了良好的基础，非常给力哦！ </span></p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>魏宇对变革本身就是适应的状态，并且在变革中取得了不错的成绩，这个时候的鼓励就像一针强心针，能够有助变革顺利进行。</p></div>'+
            //   '<p>接下来是项目经理林薇汇报工作。</p><p><span class="fontLW">林薇</span><span>老大，我已经把项目的整体排期方案做好了，但是涉及到数据分析方面的内容还没有开始做，因为市场部迟迟没有给到数据。【具体内容，成果一般，需要协助】</span></p><p><span class="fontBlue">我</span><span>你的排期方案做得非常细致，考虑很周全，不亏是公认的“大管家”。拿不到市场部数据会导致延期，你准备怎么跟进？</span></p><p><span class="fontLW">林薇</span><span>催了几次都不见效果，我打算约他们主管谈下，看看到底什么情况。</span></p><p>【导师反馈】维护自尊，鼓励参与，让下属动起来。</p><p><span class="fontBlue">我</span><span>嗯，了解清楚状况再看看怎么解决比较好，反复催可能不会有效果。谈完后如果有需要我帮忙的地方告诉我。</span></p><p><span class="fontLW">林薇</span><span>谢谢老大的建议和支持，我尽快了解清楚后再采取行动。</span></p><p>【导师反馈】鼓励建议加支持，效果翻倍。墙都不扶就服你！</p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>变革本身就是不易的，林薇一开始对变革持观望态度，在进度一般的情况下，指责和不信任都会让她失去继续进行下去的信心，给予支持才能够让她有动力将变革进行到底。</p></div>' +
            //   '<p>最后，是产品设计师柯胜汇报工作。</p><p><span class="fontKS">柯胜</span><span>老大，我这边的部分，因为难度确实比较大，我花了大半个月的时间才刚刚了解完市场情况，做完调研报告，具体的情况是……（进度不佳，成果一般）。【具体内容，进展缓慢】</span></p><p><span class="fontBlue">我</span><span>你调研报告中的目标客户群体分析，让我们看到原本的假设里面忽略的部分，而且你的验证非常确凿，对后面产品的设计有很大的参考价值。</span></p><p><span class="fontKS">柯胜</span><span>非常感谢老大的认可，接下来我会更加努力的！</span></p><p>【导师反馈】肯定下属的成果，维护自尊。给你99分，剩下1分怕你骄傲。</p><p><span class="fontBlue">我</span><span>关于进度的问题，你这边是有什么困难吗？</span></p><p><span class="fontKS">柯胜</span><span>产品设计过程中牵涉到的人比较多，前期讨论时，很难约大家的时间。另外，因为没能及时调整方案，并且通知项目组其他人，所以项目进展不太顺利。</span></p><p>【导师反馈】循循善诱让下属敞开心扉，继续努力哦！</p><p><span class="fontBlue">我</span><span>我又要顾着调整方案，又要协调那么多人员，你的确不容易啊！那接下来有什么计划赶上进度吗？</span></p><p><span class="fontKS">柯胜</span><span>目前我们已经调整了方案，现在的计划是……（叙述计划）</span></p><p>【导师反馈】下属胸有成竹，胜利在望的感觉不错吧？</p><p><span class="fontBlue">我</span><span>嗯，有任何问题，可以随时找我。你是我们的骨干产品设计师，相信你能很快赶上进度，保证我们如期交付。</span></p><p><span class="fontKS">柯胜</span><span>老大，我一定不负众望。</span></p><p>【导师反馈】下属信心满满，干劲十足。看好你哟！</p><div class="bg-lightOrange"><p class="excellentDemonstrationTitle"> 点 评</p><p>变革的过程中，柯胜一直持抗拒的态度。在进度不佳的状况下，你不仅不应该大骂一顿，反而应该看到他值得肯定的地方维护自尊，运用提问的方式帮助他找出跟上进度的方案。</p></div><p>会议结束，项目持续进行中…</p>';
            _this.apiService.ajax({
                'type': 'get',
                'url': '/api/exerciseTutor/' + _this.exerciseId
            }).subscribe(function (result) {
                _this.tutor = result.tutor;
                _this.optimum = result.optimum;
            });
        });
    };
    CasePracticeRevolutionReportComponent.prototype.updateExerciseReports = function () {
        var _this = this;
        this.apiService.ajax({
            'type': 'get',
            'url': '/sr/insideapi/updateExerciseReports?exerciseId=' + this.exerciseId
        }).subscribe(function (result) {
            _this.getKasInfo();
        });
    };
    CasePracticeRevolutionReportComponent.prototype.getKasInfo = function () {
        var _this = this;
        this.apiService.ajax({
            'type': 'get',
            // 'url':'/api/practices/'+this.exerciseId+'/'+this.practiceId+'/report'
            'url': '/sr/driveChange/reports/' + this.exerciseId + '/' + this.practiceId
        }).subscribe(function (result) {
            //无报告数据转向列表页
            _this.practiceMetaId = result.practiceMetaId;
            _this.report = result.reports.kas;
            _this.reportName = result.reports.name;
            _this.finished = result.allExerciseFinished;
            _this.getLevelInfo(result.reports);
        });
    };
    CasePracticeRevolutionReportComponent.prototype.getLevelInfo = function (reports) {
        var _this = this;
        var that = this;
        $.ajax({
            url: "/sr/insideapi/getlevel",
            type: "post",
            dataType: 'json',
            contentType: 'application/json;charset=utf-8',
            data: JSON.stringify(this.getKaList(reports)),
            async: false,
            headers: {
                'transtalen-token': localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '',
                'transtalenuserid': localStorage.getItem('transtalenuserid') ? localStorage.getItem('transtalenuserid') : ''
            },
            success: function (result) {
                if (result && result != "") {
                    that.reportKAData = result;
                    that.targetShow = 1;
                }
                else {
                    that.targetShow = 0;
                }
            },
            error: function (er) {
                that.targetShow = 0;
                if (er.status === 401 && Number(er.responseJSON.code) === 106) {
                    that.storeService.notification.notAuthed.next(true);
                }
            }
        });
        if (reports.name == '组织与计划') {
            this.mode = 2;
            if (that.targetShow == 0) {
                this.lvCls = this.mode + '';
            }
            else {
                this.lvCls = this.mode + ' bgBlur';
            }
            this.starPicUrl = '/casepracticepando/star2.png';
        }
        else if (reports.name == '影响力') {
            this.mode = 3;
            if (that.targetShow == 0) {
                this.lvCls = this.mode + '';
            }
            else {
                this.lvCls = this.mode + ' bgBlur';
            }
            this.starPicUrl = '/casepracticeteam/star_report.png';
        }
        else if (reports.name == '驱动变革') {
            this.mode = 4;
            if (that.targetShow == 0) {
                this.lvCls = this.mode + '';
            }
            else {
                this.lvCls = this.mode + ' bgBlur';
            }
            this.starPicUrl = '/casepracticeteam/star_report2.png';
        }
        else {
            this.mode = 1;
            if (that.targetShow == 0) {
                this.lvCls = this.mode + '';
            }
            else {
                this.lvCls = this.mode + ' bgBlur';
            }
            this.starPicUrl = '/casepracticeteam/star_report.png';
        }
        if (that.targetShow === 0) {
            this.isShowReportLv = false;
        }
        else {
            this.isShowReportLv = true;
        }
        setTimeout(function () {
            _this.itemClickEnable = true;
        }, 500);
    };
    CasePracticeRevolutionReportComponent.prototype.ngAfterViewInit = function () {
        var that = this;
        this.commonService.initPage({
            'backgroundColor': 'white'
        });
        $(document).ready(function () {
            var listenerTimeout = setInterval(function () {
                var bestPathEle = document.getElementById('bestPathBox'), analysisEle = document.getElementById('analysisContent'), tutorEle = document.getElementById('tourReviewBox');
                if (bestPathEle !== null && analysisEle !== null && tutorEle != null) {
                    bestPathEle.addEventListener('scroll', that.onBestPathScroll);
                    analysisEle.addEventListener('scroll', that.onAnalysisScroll);
                    tutorEle.addEventListener('scroll', that.onTutorScroll);
                    clearInterval(listenerTimeout);
                }
            }, 500);
        });
    };
    /*
      格式化KA对象方法
       report：传递一个报告对象
     */
    CasePracticeRevolutionReportComponent.prototype.getKaList = function (report) {
        var kaJson = { id: report.id, name: report.name, type: report.type, kas: {}, exercisesId: this.exerciseId, questionId: null, optionId: null };
        if (window["exercises" + this.exerciseId] != null) {
            var exerciseConfig = window["exercises" + this.exerciseId];
            kaJson.questionId = exerciseConfig.questionId;
            kaJson.optionId = exerciseConfig.optionId;
        }
        if (report) {
            for (var i = 0; i < report.kas.length; i++) {
                var kaItem = report.kas[i];
                if (kaItem) {
                    //kaJson.kas.push({name:kaItem.name,value:Number(kaItem.value)});
                    kaJson.kas[kaItem.name] = kaItem.value;
                }
            }
        }
        return kaJson;
    };
    CasePracticeRevolutionReportComponent.prototype.close = function () {
        var _this = this;
        this.apiService.ajax({
            'type': 'get',
            'url': '/api/learningpathes/' + this.learningPathId
        }).subscribe(function (result) {
            //转向情景列表
            var link = _this.abilityConfig.getPracticeLinkList(result.name, _this.learningPathId, _this.practiceMetaId);
            if (link.length > 0) {
                if (_this.type) {
                    _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                }
                else {
                    _this.router.navigate(link);
                }
            }
        });
    };
    CasePracticeRevolutionReportComponent.prototype.onBestPathScroll = function () {
        var overlay = document.getElementById('bestPathBox');
        if (overlay.scrollTop < 1) {
            overlay.scrollTop = 1;
        }
        else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight < 1) {
            overlay.scrollTop = overlay.scrollTop - 1;
        }
    };
    CasePracticeRevolutionReportComponent.prototype.onAnalysisScroll = function () {
        var overlay = document.getElementById('analysisContent');
        console.log("scroll1");
        if (overlay.scrollTop < 1) {
            overlay.scrollTop = 1;
        }
        else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight < 1) {
            overlay.scrollTop = overlay.scrollTop - 1;
        }
    };
    CasePracticeRevolutionReportComponent.prototype.onTutorScroll = function () {
        var overlay = document.getElementById('tourReviewBox');
        if (overlay.scrollTop < 1) {
            overlay.scrollTop = 1;
        }
        else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight < 1) {
            overlay.scrollTop = overlay.scrollTop - 1;
        }
    };
    CasePracticeRevolutionReportComponent.prototype.subWrapOneOut = function () {
        $('#subWrapOne').fadeOut(function () {
            $('#subWrapTwo').fadeIn();
            $('#btnWrap').fadeIn();
        });
    };
    CasePracticeRevolutionReportComponent.prototype.tourReviewBoxIn = function () {
        $('#tourReviewShade').fadeIn();
        $('#tourReviewBox').fadeIn();
        $('.closeBtn' + this.skinColor).fadeIn();
        this.pathClickable = false;
    };
    CasePracticeRevolutionReportComponent.prototype.tourReviewBoxOut = function () {
        $('#tourReviewShade').fadeOut();
        $('#tourReviewBox').fadeOut();
        $('.closeBtn' + this.skinColor).fadeOut();
        this.pathClickable = true;
    };
    CasePracticeRevolutionReportComponent.prototype.bestPathIn = function () {
        if (!this.pathClickable) {
            return;
        }
        $('.closeBtn' + this.skinColor).fadeIn();
        this.bestPathBoxShow = true;
        $('#shade').fadeIn();
    };
    CasePracticeRevolutionReportComponent.prototype.bestPathOut = function () {
        $('.closeBtn' + this.skinColor).fadeOut();
        this.bestPathBoxShow = false;
        $('#shade').fadeOut();
    };
    CasePracticeRevolutionReportComponent.prototype.redo = function () {
        var _this = this;
        if (!this.pathClickable || this.redoClickedStatus) {
            return;
        }
        else {
            this.redoClickedStatus = true;
        }
        this.apiService.ajax({
            'type': 'get',
            'url': '/sr/driveChange/reset/' + this.exerciseId
        }).subscribe(function (result) {
            // let link = ['case-practice-revolution',this.learningPathId,this.practiceMetaId];
            var link = ['case-practice-revolution', _this.practiceId, _this.exerciseId, _this.learningPathId, _this.practiceMetaId];
            if (_this.type) {
                _this.router.navigate(link, { queryParams: { type: 'huatek' } });
            }
            else {
                _this.router.navigate(link);
            }
        });
    };
    CasePracticeRevolutionReportComponent.prototype.analysisBoxIn = function (i) {
        if (!this.itemClickEnable) {
            return false;
        }
        var _this = this;
        this.currentName = this.report[i].name;
        this.currentDescription = this.report[i].description;
        this.currentTotal = this.report[i].value;
        this.currentAnalysis = this.report[i].analysis;
        $('#analysisShade').fadeIn();
        // 滚动到订端
        $('#analysisContent').scrollTop(0);
        // $('#analysisBox').fadeIn();
        this.analysisBoxShow = true;
        $('body').css('overflow-y', 'hidden');
        setTimeout(function () {
            _this.starShow = true;
        }, 300);
        this.pathClickable = false;
        document.getElementById('analysisShade').ontouchmove = function (e) { e.preventDefault(); };
        document.getElementById('analysisHead').ontouchmove = function (e) { e.preventDefault(); };
        document.getElementById('closeBtn3').ontouchmove = function (e) { e.preventDefault(); };
    };
    CasePracticeRevolutionReportComponent.prototype.analysisBoxOut = function () {
        $('#analysisShade').fadeOut();
        this.analysisBoxShow = false;
        $('body').css('overflow-y', 'scroll');
        this.starShow = false;
        this.pathClickable = true;
    };
    CasePracticeRevolutionReportComponent.prototype.goToList = function () {
        var _this = this;
        if (this.goToListClickedStatus) {
            return;
        }
        else {
            this.goToListClickedStatus = true;
        }
        this.apiService.ajax({
            'type': 'get',
            'url': '/api/learningpathes/' + this.learningPathId
        }).subscribe(function (result) {
            //转向情景列表
            var link = _this.abilityConfig.getPracticeLinkList(result.name, _this.learningPathId, _this.practiceMetaId);
            if (link.length > 0) {
                if (_this.type) {
                    _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                }
                else {
                    _this.router.navigate(link);
                }
            }
        });
    };
    CasePracticeRevolutionReportComponent.prototype.linkToPostSurvey = function () {
        var _this = this;
        this.apiService.ajax({
            'type': 'get',
            'url': '/ddilearner/v1/getLearningPathMetaId/' + this.learningPathId
        }).subscribe(function (result) {
            _this.learningPathMetaId = result;
            _this.apiService.getOrCreateLearningPath(_this.learningPathMetaId).subscribe(function (result) {
                _this.learningPath = result.data;
                if (_this.learningPath.subItems.length == 3) {
                    _this.apiService.ajax({
                        'type': 'get',
                        'url': '/sr/learningtour',
                    }).subscribe(function (result) {
                        _this.learningTour = result;
                        var link = ['survey', _this.learningTour.tour_id, 3, 2];
                        _this.router.navigate(link);
                    });
                }
                else {
                    var link = ['survey', _this.learningPath.id, _this.learningPath.subItems[4].surveyMetaId, 1];
                    _this.router.navigate(link);
                }
            });
        });
    };
    return CasePracticeRevolutionReportComponent;
}());
export { CasePracticeRevolutionReportComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-revolution-report/case-practice-revolution-report.component.ts.pre-build-optimizer.js